import { FC } from "react";
import { EmptyStates } from "components";

export const EmptyStatesGenetics: FC = () => {
  return (
    <EmptyStates title="No genetic data found." animation="searching">
      <p>Upload genetic data for this animal to view it here.</p>
    </EmptyStates>
  );
};
